import { FC } from "react"
import { usePendingSubscriptionsCount } from "../../hooks"
import { MAX_DREAM_RATE_COUNT } from "../../constants/dream-rate"
import UsageBadge from "./usage-badge"

type Props = {
  // Optional override to customize the fetch arg (e.g., brand/org filters)
  queryArgs?: Record<string, any>
  className?: string
  variant?: "badge" | "text"
}

const DreamRateUsageBadge: FC<Props> = ({
  queryArgs,
  className,
  variant = "badge"
}) => {
  const { count, isFetching } = usePendingSubscriptionsCount({ queryArgs })

  // Hide while loading
  if (isFetching) {
    return null
  }

  if (variant === "text") {
    return (
      <span
        className={className}
        aria-label={`Usage ${count} of ${MAX_DREAM_RATE_COUNT}`}
      >
        {count}/{MAX_DREAM_RATE_COUNT} Used
      </span>
    )
  }

  return (
    <UsageBadge
      count={count}
      max={MAX_DREAM_RATE_COUNT}
      className={className}
    />
  )
}

export default DreamRateUsageBadge
